export const scrollToMain = () => document.querySelector('.main-container').scrollIntoView({ block: 'start', behavior: 'smooth' })